import { useAuth } from "@elit-hair/elit-tools";
import { Button } from "@elit-hair/elit-ui";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useGuidedTourContext } from "@/components/guided-tour/guided-tour-context";
import { ENV } from "@/constants/env";
import { cn } from "@/lib/utils";
import { SentryTest } from "@/pages/settings-page/components/sentry-test";
import { SettingsPanel } from "@/pages/settings-page/components/settings-panel";

function SettingsPage() {
    const { t } = useTranslation();
    const { userData, handleLogout } = useAuth();

    const [userPermissionsOpen, setUserPermissionsOpen] = useState(false);
    const { restartTour } = useGuidedTourContext();

    return (
        <div className="overflow-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 auto-rows-auto">
                <div className="flex flex-col bg-background shadow-sm p-4 gap-4 rounded-lg border border-border">
                    <SettingsPanel />
                </div>

                <div className="flex flex-col bg-background shadow-sm p-4 gap-4 rounded-lg border border-border">
                    <div className="flex flex-col gap-0 mb-2">
                        <h3 className="text-lg font-semibold">
                            {t("user")}: {userData?.name}
                        </h3>
                        <h5 className="text-xs text-muted-foreground">
                            {t("id")}: {userData?.id}
                        </h5>
                    </div>
                    <div className="flex flex-col gap-1">
                        <Button variant="destructive" onClick={handleLogout}>
                            {t("logout")}
                        </Button>
                    </div>
                    <Button variant="outline" onClick={() => setUserPermissionsOpen(!userPermissionsOpen)}>
                        {t("user_permissions")}
                    </Button>
                    {userPermissionsOpen && (
                        <div className="flex flex-col mt-2">
                            <div className="flex flex-wrap gap-1">
                                {userData?.permissionCodes.map((permission) => (
                                    <div
                                        key={permission}
                                        className={cn(
                                            "px-2 py-1 border border-primary/20 bg-primary/10 rounded-full text-xs",
                                            "hover:text-sm hover:px-3 transition-all flex justify-center items-center"
                                        )}
                                    >
                                        {permission}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <Button onClick={restartTour} variant="secondary">
                        {t("restart_tour")}
                    </Button>
                </div>
                {ENV.DEV && (
                    <div className="flex flex-col bg-background shadow-sm p-4 gap-4 rounded-lg border border-border">
                        <SentryTest />
                    </div>
                )}
            </div>
        </div>
    );
}

export const Route = createFileRoute("/settings")({
    component: SettingsPage,
});
